import React, { Children, useEffect, useState } from "react"
import { createStructuredSelector } from "reselect"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import { compose } from "redux"
import { map, groupBy, orderBy, find } from "lodash"
// Components
import StepHeader from "./components/StepHeader"
import RowGantt from "./components/RowGantt"
// Actions
import { getBusinessUsersAction } from "Containers/BusinessInformations/actions"
// Selectors
import { selectBusinessUsers } from "Containers/BusinessInformations/selectors"
// Utils
import {
  handlePhaseCompletion,
  getTiming,
  checkInfosStep,
} from "Components/MSF/CaseFile/utils/utils"
// Style
import { GanttChartContainer, GanttBody } from "./index.style"

const GanttChartV1 = ({
  dataChart,
  valueData,
  categoryData,
  fieldsData,
  ganttColumns,
  columnsLabelsMapping,
  primaryActionColor,
  listBusinessUsers,
  dispatchGetUsers,
  ...otherProps
}) => {
  useEffect(() => {
    dispatchGetUsers()
  }, [])
  // Function
  const transformSourceDataInArrayData = (sourceData, sourceColumn) => {
    const source = sourceData || []
    const data = map(source, item => {
      let objectData = {}
      for (const [key, value] of Object.entries(item)) {
        objectData = {
          ...objectData,
          [getNameColumnUuid(sourceColumn, key)]: value,
        }
      }
      return objectData
    })
    return data
  }

  // Récupération le nom de la colonne par rapport à l'uuid
  const getNameColumnUuid = (sourceColumn, uuid) => {
    return sourceColumn?.find(col => col.valueId === uuid)?.label
  }

  const dataSource = transformSourceDataInArrayData(dataChart, columnsLabelsMapping)
  const dataSourceGroup = groupBy(dataSource, "idCase")
  const dataMapping = map(dataSourceGroup, caseData => {
    const responseAffaire = groupBy(caseData, (item) => `"${item.phase}-${item.step}"`)
    const transformedResponse = Object.values(responseAffaire).reduce((result, items) => {
      const mostRecentDate = items.reduce((prevItem, currentItem) => {
        const prevDate = prevItem["updated_at"]
        const currentDate = currentItem["updated_at"]
        return currentDate > prevDate ? currentItem : prevItem
      })
      return [...result, mostRecentDate]
    }, [])
    const phaseCompletion = handlePhaseCompletion(transformedResponse, fieldsData)
    const stepInfos = checkInfosStep(responseAffaire, phaseCompletion, listBusinessUsers)
    const getDateStartTiming = find(responseAffaire, { step: "dcs_reception_date" })
    const dateStartTiming = getDateStartTiming?.response
    const phaseDaysToAdd = stepInfos?.inProgressNameStep === "Analyse du besoin" ? 35 : 122
    const timingAffaire = getTiming(dateStartTiming, phaseDaysToAdd)

    return {
      step: stepInfos?.step,
      name: caseData[0]?.reference,
      created_date_affaire: caseData[0]?.created_at,
      inProgressNameStep: stepInfos?.inProgressNameStep,
      afterNameStep: stepInfos?.afterNameStep,
      timming: timingAffaire,
      advancementStep: stepInfos?.advancementStep,
      responsableInProgressStep: stepInfos?.responsableOne,
      responsableAfterStep: stepInfos?.responsableTwo,
      phaseCompletion: phaseCompletion,
      item: caseData,
    }
  })
  const data = orderBy(dataMapping, ["created_date_affaire"], ["desc"])

  const nbColumns = ganttColumns?.length || 0

  return (
    <GanttChartContainer>
      <StepHeader columns={ganttColumns} color={primaryActionColor} />
      <GanttBody>
        {Children.toArray(
          data?.map(row => {
            const isDelay = row?.timming?.timingStatus === "delay"
            return (
              <RowGantt
                responsableInProgressStep={row?.responsableInProgressStep}
                responsableAfterStep={row?.responsableAfterStep}
                inProgressNameStep={row?.inProgressNameStep}
                advancementStep={row?.advancementStep}
                afterNameStep={row?.afterNameStep}
                timming={row?.timming?.timingName}
                nbColumns={nbColumns}
                isDelay={isDelay}
                step={row?.step}
                name={row?.name}
              />
            )
          })
        )}
      </GanttBody>
    </GanttChartContainer>
  )
}

GanttChartV1.propTypes = {
  valueData: PropTypes.array,
  categoryData: PropTypes.string,
  primaryActionColor: PropTypes.string,
  dataChart: PropTypes.array,
  fieldsData: PropTypes.array,
  ganttColumns: PropTypes.array,
}

GanttChartV1.defaultProps = {
  valueData: [],
  categoryData: "",
  primaryActionColor: "",
  dataChart: [],
  fieldsData: [],
  ganttColumns: [
    "Phase 1: Analyse",
    "Phase 2: Validation du DCS",
    "Phase 3: Validation NSF",
    "Phase 4: Réalisation travaux",
  ],
  columnsLabelsMapping: [],
}

const mapDispatchToProps = dispatch => ({
  dispatchGetUsers: core => dispatch(getBusinessUsersAction(core)),
})

const mapStateToProps = createStructuredSelector({
  listBusinessUsers: selectBusinessUsers,
})

export default compose(connect(mapStateToProps, mapDispatchToProps))(GanttChartV1)
